const Loading = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      padding: '80px 0',
      boxSizing: 'border-box'
    }}>
      <div style={{ position: 'relative', width: '60px', height: '60px' }}>
        <style>{`
          @keyframes square-animation {
            0% {
              left: 0;
              top: 0;
            }
            10.5% {
              left: 0;
              top: 0;
            }
            12.5% {
              left: 20px;
              top: 0;
            }
            23% {
              left: 20px;
              top: 0;
            }
            25% {
              left: 40px;
              top: 0;
            }
            35.5% {
              left: 40px;
              top: 0;
            }
            37.5% {
              left: 40px;
              top: 20px;
            }
            48% {
              left: 40px;
              top: 20px;
            }
            50% {
              left: 20px;
              top: 20px;
            }
            60.5% {
              left: 20px;
              top: 20px;
            }
            62.5% {
              left: 20px;
              top: 40px;
            }
            73% {
              left: 20px;
              top: 40px;
            }
            75% {
              left: 0;
              top: 40px;
            }
            85.5% {
              left: 0;
              top: 40px;
            }
            87.5% {
              left: 0;
              top: 20px;
            }
            98% {
              left: 0;
              top: 20px;
            }
            100% {
              left: 0;
              top: 0;
            }
          }
          .loader-container {
            position: relative;
            width: 60px;
            height: 60px;
            transform: rotate(45deg);
          }
          .loader-square {
            position: absolute;
            top: 0;
            left: 0;
            width: 17px;
            height: 17px;
            margin: 0px;
            border-radius: 0px;
            background: black;
            animation: square-animation 10s ease-in-out infinite both;
          }
          .loader-square:nth-of-type(1) {
            animation-delay: -1.4285714286s;
          }
          .loader-square:nth-of-type(2) {
            animation-delay: -2.8571428571s;
          }
          .loader-square:nth-of-type(3) {
            animation-delay: -4.2857142857s;
          }
          .loader-square:nth-of-type(4) {
            animation-delay: -5.7142857143s;
          }
          .loader-square:nth-of-type(5) {
            animation-delay: -7.1428571429s;
          }
          .loader-square:nth-of-type(6) {
            animation-delay: -8.5714285714s;
          }
          .loader-square:nth-of-type(7) {
            animation-delay: -10s;
          }
        `}</style>

        <div className="loader-container">
          <div className="loader-square"></div>
          <div className="loader-square"></div>
          <div className="loader-square"></div>
          <div className="loader-square"></div>
          <div className="loader-square"></div>
          <div className="loader-square"></div>
          <div className="loader-square"></div>
        </div>
      </div>

      <p style={{
        textAlign: 'center',
        color: 'var(--color-text-muted)',
        fontFamily: 'var(--font-mono)',
        fontSize: '12px',
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
        marginTop: '24px'
      }}>
        Loading
      </p>
    </div>
  );
};

export default Loading;